import { render, staticRenderFns } from "./dragImg.vue?vue&type=template&id=7df9047e&scoped=true&"
import script from "./dragImg.vue?vue&type=script&lang=js&"
export * from "./dragImg.vue?vue&type=script&lang=js&"
import style0 from "./dragImg.vue?vue&type=style&index=0&id=7df9047e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df9047e",
  null
  
)

export default component.exports